import React from "react";

export const CustomEditor = React.lazy(
    () => import("@callveriq/modules/lms/knowledgeBase/components/CustomEditor")
);
export const CustomerIntelligence = React.lazy(
    () => import("@callveriq/modules/customerInteligence")
);
export const SupervisorAssist = React.lazy(
    () => import("@callveriq/modules/SupervisorAssist")
);

export const B2BAuditDashboard = React.lazy(
    () =>
        import(
            "@callveriq/modules/home/analatyicsDashboard/modules/B2BAuditDashboard"
        )
);

export const ConversationRoutes = React.lazy(
    () => import("@callveriq/modules/routes/ConversationRoutes")
);
export const CreateQmsConversation = React.lazy(
    () => import("@callveriq/modules/qms/components/CreateQmsConversation")
);
export const MeetingsDashboard = React.lazy(
    () => import("@callveriq/modules/MeetingsDashboard")
);

export const AiVoiceCall = React.lazy(
    () => import("@callveriq/modules/aiVoiceCall")
);

export const CoachingDashboard = React.lazy(
    () => import("@callveriq/modules/coaching")
);

export const Settings = React.lazy(
    () => import("@callveriq/modules/settings/Settings")
);

export const AccountsDashboard = React.lazy(
    () => import("@callveriq/modules/accounts")
);

export const HomeDashboard = React.lazy(() => import("@callveriq/modules/home"));

export const LMS = React.lazy(() => import("@callveriq/modules/lms"));

export const AssessmentAgentView = React.lazy(
    () => import("@callveriq/modules/coaching/assements/AssessmentAgentView")
);

export const LockedState = React.lazy(
    () => import("@callveriq/components/custom_components/reuseable/LockedState")
);

export const BertRuleEngine = React.lazy(
    () =>
        import(
            "@callveriq/modules/settings/modules/auditManager/components/bertRuleEngine/RuleEngineEntry"
        )
);

export const SalesAssistIframe = React.lazy(
    () => import("@callveriq/components/custom_components/SalesAssistIframe")
);

export const UserProfile = React.lazy(
    () => import("@callveriq/modules/settings/modules/userProfile")
);

export const ActivityLog = React.lazy(
    () => import("@callveriq/modules/ActivityLog")
);

export const TestRule = React.lazy(
    () =>
        import(
            "@callveriq/modules/settings/modules/auditManager/components/bertRuleEngine/components/TestRule/TestRule"
        )
);
